<template>
    <div class="not-found">
        <BaseCard class="p-shadow-3 not-found-card">
            <template #title>
                <h2 class="text-semibold">Page Introuvable</h2>
            </template>
            <template #content>
                <p>Oops! La page que vous recherchez n'existe pas.</p>
                <BaseButton as-child v-slot="slotProps">
                    <RouterLink to="/" :class="[slotProps.class, 'mt-8']">
                        Retour à l'accueil
                    </RouterLink>
                </BaseButton>
            </template>
        </BaseCard>
    </div>
</template>

<style scoped>
.not-found {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    text-align: center;
}

.not-found-card {
    max-width: 400px;
    padding: 2rem;
}
</style>
